import { Routes, Route } from "react-router-dom";
import Login from "../pages/login/index.tsx";
import Dashboard from "../pages/dashboard/index.tsx";
import DashboardLayout from "../layouts/DashboardLayout.tsx";
import ProtectedRoute from "./ProtectedRoute.jsx";
import SubCategories from "../pages/subCategories/index.tsx";
import SubCategoryCreateEdit from "../pages/subCategories/createEdit.tsx";
import ProductCreateEdit from "../pages/products/createEdit.tsx";
import ProductsList from "../pages/products/index.tsx";
import VariantManagement from "../pages/products/variantManagement.tsx";
import EmployeesList from "../pages/employees/index.tsx";
import EmployeeCreateEdit from "../pages/employees/createEdit.tsx";
import MasterServices from "../pages/masterServices/index.tsx";
import MasterServiceCreateEdit from "../pages/masterServices/createEdit.tsx";
import Natures from "../pages/natures/index.tsx";
import NatureCreateEdit from "../pages/natures/createEdit.tsx";
import Ledgers from "../pages/ledgers/index.tsx";
import LedgerCreateEdit from "../pages/ledgers/createEdit.tsx";
import BankAccountsList from "../pages/bankAccounts/index.tsx";
import BankAccountCreateEdit from "../pages/bankAccounts/createEdit.tsx";
import CashTransferCreate from "../pages/cashTransfer/index.tsx";
import WashesList from "../pages/washes/index.tsx";
import WashCreateEdit from "../pages/washes/createEdit.tsx";
import CustomersList from "../pages/customers/index.tsx";
import CustomerCreateEdit from "../pages/customers/createEdit.tsx";
import VehiclesList from "../pages/vehicles/index.tsx";
import VehicleCreateEdit from "../pages/vehicles/createEdit.tsx";
import EntriesList from "../pages/entries/index.tsx";
import EntryCreateEdit from "../pages/entries/createEdit.tsx";
import TransactionReport from "../pages/reports/transactionReport/index.tsx";
import PublicDashboard from "../pages/publicDashboard/index.tsx";
function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/wash-status" element={<PublicDashboard />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index path="dashboard" element={<Dashboard />} />
        <Route path="entries" element={<EntriesList />} />
        <Route path="entries/create" element={<EntryCreateEdit />} />
        <Route path="entries/:id" element={<EntryCreateEdit />} />
        {/* <Route path="sub-categories" element={<SubCategories />} />
        <Route
          path="sub-categories/create"
          element={<SubCategoryCreateEdit />}
        /> */}
        {/* Need to delete this route after integration */}
        {/* <Route path="sub-categories/:id" element={<SubCategoryCreateEdit />} />
        <Route path="products/create" element={<ProductCreateEdit />} />
        <Route path="products/:id" element={<ProductCreateEdit />} />
        <Route path="products" element={<ProductsList />} />
        <Route
          path="products/:productId/:categoryId/variant-management"
          element={<VariantManagement />}
        /> */}
        {/* Need to delete this route after integration */}
        <Route path="employees" element={<EmployeesList />} />
        <Route path="employees/create" element={<EmployeeCreateEdit />} />
        <Route path="employees/:id" element={<EmployeeCreateEdit />} />
        <Route path="master-services" element={<MasterServices />} />
        <Route
          path="master-services/create"
          element={<MasterServiceCreateEdit />}
        />
        <Route
          path="master-services/:id"
          element={<MasterServiceCreateEdit />}
        />
        <Route path="natures" element={<Natures />} />
        <Route path="natures/create" element={<NatureCreateEdit />} />
        <Route path="natures/:id" element={<NatureCreateEdit />} />
        <Route path="ledgers" element={<Ledgers />} />
        <Route path="ledgers/create" element={<LedgerCreateEdit />} />
        <Route path="ledgers/:id" element={<LedgerCreateEdit />} />
        <Route path="bank-accounts" element={<BankAccountsList />} />
        <Route
          path="bank-accounts/create"
          element={<BankAccountCreateEdit />}
        />
        <Route path="bank-accounts/:id" element={<BankAccountCreateEdit />} />
        <Route path="cash-transfer" element={<CashTransferCreate />} />
        <Route path="cash-transfer/create" element={<CashTransferCreate />} />
        <Route path="cash-transfer/:id" element={<CashTransferCreate />} />
        <Route path="washes" element={<WashesList />} />
        <Route path="washes/create" element={<WashCreateEdit />} />
        <Route path="washes/:id" element={<WashCreateEdit />} />
        <Route path="customers" element={<CustomersList />} />
        <Route path="customers/create" element={<CustomerCreateEdit />} />
        <Route path="customers/:id" element={<CustomerCreateEdit />} />
        <Route path="vehicles" element={<VehiclesList />} />
        <Route path="vehicles/create" element={<VehicleCreateEdit />} />
        <Route path="vehicles/:id" element={<VehicleCreateEdit />} />
        <Route
          path="transaction-report"
          element={<TransactionReport />}
        />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
